import { useEffect, useState } from 'react';

const navLinks = [
  { label: '首页', href: '#top' },
  { label: '核心功能', href: '#features' },
  { label: '热门追更', href: '#trending' },
  { label: '分类书库', href: '#categories' },
  { label: '使用指南', href: '#guide' },
  { label: '常见问题', href: '#faq' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-background-50/90 backdrop-blur-md shadow-sm' : 'bg-transparent'
      }`}
    >
      <nav className="mx-auto flex h-16 md:h-[72px] max-w-7xl items-center justify-between px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2.5">
          <span
            className={`flex h-9 w-9 items-center justify-center rounded-xl ${
              scrolled ? 'bg-primary-500 text-background-50' : 'bg-background-50/90 text-primary-600'
            }`}
          >
            <i className="ri-flower-line text-xl" />
          </span>
          <span
            className={`font-heading text-lg font-bold tracking-tight ${
              scrolled ? 'text-foreground-950' : 'text-white'
            }`}
          >
            樱花漫画
          </span>
        </a>

        <ul className="hidden items-center gap-1 md:flex">
          {navLinks.map((link) => (
            <li key={link.href}>
              <a
                href={link.href}
                className={`rounded-full px-4 py-2 text-sm font-medium whitespace-nowrap transition-colors ${
                  scrolled
                    ? 'text-foreground-700 hover:bg-primary-100 hover:text-primary-700'
                    : 'text-white/90 hover:bg-white/15 hover:text-white'
                }`}
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="flex items-center gap-2">
          <a
            href="#guide"
            className={`hidden whitespace-nowrap rounded-full px-5 py-2.5 text-sm font-semibold transition-colors sm:inline-flex ${
              scrolled
                ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                : 'bg-background-50/95 text-primary-700 hover:bg-white'
            }`}
          >
            立即体验
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setOpen((v) => !v)}
            className={`flex h-10 w-10 items-center justify-center rounded-full md:hidden ${
              scrolled ? 'text-foreground-900 hover:bg-primary-100' : 'text-white hover:bg-white/15'
            }`}
          >
            <i className={`${open ? 'ri-close-line' : 'ri-menu-line'} text-2xl`} />
          </button>
        </div>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-4 md:hidden">
          <ul className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  onClick={() => setOpen(false)}
                  className="block rounded-lg px-3 py-2.5 text-sm font-medium text-foreground-800 hover:bg-primary-100 hover:text-primary-700"
                >
                  {link.label}
                </a>
              </li>
            ))}
            <li className="mt-2">
              <a
                href="#guide"
                onClick={() => setOpen(false)}
                className="block rounded-full bg-primary-500 px-3 py-2.5 text-center text-sm font-semibold text-background-50 hover:bg-primary-600"
              >
                立即体验
              </a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}